var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full test",style:({backgroundSize:_vm.bgs}),attrs:{"id":"mainFull"}})}
var staticRenderFns = []

export { render, staticRenderFns }